



















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name: 'SidebarLogo',
})
export default class extends Vue {
  @Prop({ required: true }) private collapse!: boolean
  private title = 'Company'
}
